import { render } from "./ContestHero.vue?vue&type=template&id=0bac5a82&scoped=true"
import script from "./ContestHero.vue?vue&type=script&lang=js"
export * from "./ContestHero.vue?vue&type=script&lang=js"

import "./ContestHero.vue?vue&type=style&index=0&id=0bac5a82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bac5a82"]])

export default __exports__